// extracted by mini-css-extract-plugin
export default {"emptySection":"EmptySection_emptySection__Oaxhs"};